import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-exemplo-vistoria-autonoma',
  templateUrl: './exemplo-vistoria-autonoma.component.html',
  styleUrls: ['./exemplo-vistoria-autonoma.component.scss']
})
export class ExemploVistoriaAutonomaComponent implements OnInit {

  menuItems = [
    { link: 'topico0', text: 'Cabeçalho ', active: true },
    { link: 'topico1', text: 'Análise ', active: false },
    { link: 'topico2', text: 'Legenda ', active: false },
    { link: 'topico3', text: 'Observações ', active: false },
    { link: 'topico4', text: 'Arquivos ', active: false },
    { link: 'topico5', text: 'Perguntas ', active: false },
    { link: 'topico6', text: 'Avarias ', active: false },
    { link: 'topico7', text: 'Valor de Mercado ', active: false },
    { link: 'topico8', text: 'Valor Sugerido ', active: false },
    { link: 'topico9', text: 'Dados Estaduais ', active: false },
    { link: 'topico10', text: 'Veículos ofertados a Leilão ', active: false },
    { link: 'topico11', text: 'Leilão Complementar ', active: false },
    { link: 'topico12', text: 'Análise de Risco ', active: false },
  ];

  topicos = [
    { id: 0, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/primeira-imagem.png'], botoes: null },
    { id: 1, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/segunda-imagem.png'], botoes: null },
    { id: 2, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/terceira-imagem.png'], botoes: null },
    { id: 3, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/quarta-imagem.png'], botoes: null },
    { id: 4, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/quinta-imagem.png'], botoes: null },
    { id: 5, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/sexta-imagem.png'], botoes: null },
    { id: 6, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/setima-imagem.png'], botoes: null },
    { id: 7, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/oitava-imagem.png'], botoes: null },
    { id: 8, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/nona-imagem.png'], botoes: null },
    { id: 9, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/decima-imagem.png'], botoes: null },
    { id: 10, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/decima-primeira-imagem.png'], botoes: null },
    { id: 11, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/decima-segunda-imagem.png'], botoes: null },
    { id: 12, imagens: ['https://siteunion.s3.dualstack.sa-east-1.amazonaws.com/wp-content/uploads/2025/vistoria-autonoma/decima-terceira-imagem.png'], botoes: null },
  ];
  terceira

  imgAtiva = {
    1: 1,
    2: 1,
    3: 1,
    4: 1,
    5: 1,
    6: 1,
    7: 1,
    8: 1,
    9: 1,
    10: 1,
    11: 1,
    12: 1,
    13: 1,
  };

  constructor() { }

  ngOnInit(): void {
  }

  mostraImagem(topicoId: number, imgId: number) {
    this.imgAtiva[topicoId] = imgId;

    const topico = this.topicos.find(t => t.id === topicoId);
    if (topico && topico.botoes) {
      topico.botoes.forEach(botao => botao.ativo = (botao.id === imgId));
    }
  }

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.updateActiveMenuItem(id);
    }
  }

  updateActiveMenuItem(activeLink: string) {
    this.menuItems.forEach(item => item.active = (item.link === activeLink));
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const distanciaDoTopo = 150;

    this.menuItems.forEach((item) => {
      const element = document.getElementById(item.link);
      if (element) {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;

        if (elementTop <= window.scrollY + distanciaDoTopo) {
          this.updateActiveMenuItem(item.link);
        }
      }
    });
  }


}
